import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../../shared/services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { PPUAlertService } from '@app/shared/services/ppu-alert.service';

@Component({
    selector: 'app-signin-callback',
    templateUrl: './signin-callback.component.html',
    standalone: false
})
export class SigninCallbackComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private router: Router,
    private alertService: PPUAlertService,
    private translate: TranslateService
  ) {}

  async ngOnInit() {
    this.authService.userManager.signinCallback().finally(async () => {
      const isValidRole = await this.authService.isValidUserRole();
      if (!isValidRole) {
        this.alertService.errorEvent(
          this.translate.instant('App.UserNotAuthorized', {
            default: 'You are not authorized - Redirecting to login page',
          })
        );
        setTimeout(async () => {
          await this.authService.logout();
        }, 1000);
      } else {
        this.router.navigate(['']);
      }
    });
  }
}
